import React from 'react'

import useCategory from 'components/GamesNavBar/hooks/useCategory'
import useResetFilters from 'components/GamesNavBar/hooks/useResetFilters'
import useSearch from 'components/GamesNavBar/hooks/useSearch'
import { Icon } from 'components/IconLink/Icon'

import { FilterElement } from './styles'

export function Home() {
  const { search } = useSearch()
  const { category } = useCategory()
  const resetFilters = useResetFilters()

  const active = !category && search.length == 0

  return (
    <FilterElement
      active={active}
      onClick={resetFilters}
    >
      <Icon icon={'home'} />
    </FilterElement>
  )
}
